"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.regexp.split");
var _batchReservation = _interopRequireDefault(require("./components/batchReservation"));
var _authorizationDialog = _interopRequireDefault(require("./components/authorizationDialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _notificationDialog = _interopRequireDefault(require("./components/notificationDialog"));
var _blExchangeAppointmentSh = require("@/api/blExchangeAppointment/blExchangeAppointmentSh");
var _vue = require("@handsontable/vue");
var _utils = require("@/utils");
var _batchReservationXm = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/batchReservationXm.vue"));
var _batchReservationXg = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/batchReservationXg.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "blExchangeAppointmentSh",
  components: {
    batchReservationXg: _batchReservationXg.default,
    batchReservationXm: _batchReservationXm.default,
    HotColumn: _vue.HotColumn,
    batchReservation: _batchReservation.default,
    authorizationDialog: _authorizationDialog.default,
    Pagination: _Pagination.default,
    NotificationDialog: _notificationDialog.default
  },
  data: function data() {
    return {
      blNos: [],
      edoAccreditId: "",
      edoAccreditIds: "",
      accreditBlNo: "",
      loading: null,
      displayType: false,
      formDialog: {},
      tableData: [],
      // 表格数据
      tableCostData: [],
      total: 0,
      totalCost: 0,
      amount: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      listQueryTwo: {
        currentPage: 1,
        pageSize: 10
      },
      filterForm: {
        blNo: ''
      },
      hotSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      hotCostSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      initDialogVisible: false,
      // 初始化弹窗状态
      showBtnCancel: true,
      notificationDialogVisible: true,
      authorizationDialogVisible: false,
      vvLBlNo: '',
      paymentStatus: null,
      forespeakStatus: null,
      paymentStatusList: [],
      forespeakStatusList: [],
      accreditStatusList: [],
      edoPaymentMethod: [],
      rules: {
        blNo: [{
          required: true,
          message: this.$t('blExchangeAppointment.blNoNotEmpty'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    this.$dictionary.get(['EDO_PAYMENT_METHOD', 'DOC_PAYMENT_STATUS', 'DOC_FORESPEAK_STATUS', 'DOC_ACCREDIT_STATUS'], true).then(function (res) {
      _this.edoPaymentMethod = res.EDO_PAYMENT_METHOD ? res.EDO_PAYMENT_METHOD : [];
      _this.paymentStatusList = res.DOC_PAYMENT_STATUS ? res.DOC_PAYMENT_STATUS : [];
      _this.forespeakStatusList = res.DOC_FORESPEAK_STATUS ? res.DOC_FORESPEAK_STATUS : [];
      _this.accreditStatusList = res.DOC_ACCREDIT_STATUS ? res.DOC_ACCREDIT_STATUS : [];
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });
  },
  methods: {
    //查询
    handleSearch: function handleSearch() {
      var _this3 = this;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this3.loading = (0, _utils.load)();
          var blNos = _this3.filterForm.blNo.split(',');
          (0, _blExchangeAppointmentSh.queryDocEdoAccredit)(_this3.listQuery, blNos).then(function (res) {
            if (res.success) {
              _this3.total = res.data.totalRecord;
              _this3.tableData = res.data.records;
            }
          }).finally(function () {
            _this3.loading.close();
          });
        }
      });
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
      this.$refs.hotTableCost.resizeTo();
    },
    //重置
    resetFn: function resetFn() {
      this.filterForm.blNo = '';
    },
    handleBatchReservation: function handleBatchReservation() {
      var _this4 = this;
      //获取勾选行
      var hotTableSelections = this.$refs.hotTable.getSelections();
      //判断是否存在勾选数据  请勾选数据
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('blExchangeAppointment.pleaseCheckData'));
        return;
      }
      var _iterator = (0, _createForOfIteratorHelper2.default)(hotTableSelections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rowData = _step.value;
          if (!rowData.deliverableDate) {
            this.$message.error(this.$t('blExchangeAppointment.noDeliveryTime1'));
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var forespeakStatusBlNo = [];
      var unpaidBlNo = [];
      this.amount = 0;
      hotTableSelections.forEach(function (selection) {
        if (selection.forespeakStatus !== 0) {
          forespeakStatusBlNo.push(selection.blNo);
        }
        if (selection.paymentStatus === 0) {
          unpaidBlNo.push(selection.blNo);
        }
        _this4.amount = _this4.amount + Number(selection.amount);
      });
      if (forespeakStatusBlNo.length > 0) {
        this.$message.error(this.$t('blExchangeAppointment.alreadyReserved', {
          blNo: forespeakStatusBlNo.join(', ')
        }));
        return;
      }
      // if (unpaidBlNo.length > 0) {
      //   this.$message.error(this.$t('blExchangeAppointment.unpaid', {blNo: unpaidBlNo.join(', ')}));
      //   return;
      // }
      var bookingHeadIds = hotTableSelections.map(function (select) {
        return select.bookingHeadId;
      });
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointmentSh.validateDocEdoAccredit)(bookingHeadIds).then(function (res) {
        if (res.success) {
          _this4.vvLBlNo = hotTableSelections.map(function (selection) {
            return "VVL:".concat(selection.outVesselCode, "/").concat(selection.outVoyageNo).concat(selection.outVoyageLeg, ",BL:").concat(selection.blNo);
          }).join(',');
          _this4.blNos = hotTableSelections.filter(function (selection) {
            return selection.blNo;
          }).map(function (selection) {
            return selection.blNo;
          });
          _this4.paymentStatus = hotTableSelections[0].paymentStatus;
          _this4.forespeakStatus = hotTableSelections[0].forespeakStatus;
          _this4.initDialogVisible = true;
          _this4.showBtnCancel = false;
        }
      }).finally(function () {
        _this4.loading.close();
      });
    },
    //授权
    handleAuthorize: function handleAuthorize() {
      var hotTableSelections = this.$refs.hotTable.getSelections();
      //判断是否存在勾选数据  请勾选数据
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('blExchangeAppointment.pleaseCheckData'));
        return;
      }
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(hotTableSelections),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rowData = _step2.value;
          if (!rowData.deliverableDate) {
            this.$message.error(this.$t('blExchangeAppointment.noDeliveryTime'));
            return;
          }
          if (!rowData.forespeakStatus) {
            this.$message.error(this.$t('blExchangeAppointment.noReservation'));
            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var blNos = hotTableSelections.map(function (select) {
        return select.blNo;
      });
      var accreditIds = hotTableSelections.map(function (select) {
        return select.edoAccreditId;
      });
      this.accreditBlNo = blNos.join(',');
      this.edoAccreditIds = accreditIds.join(',');
      this.authorizationDialogVisible = true;
    },
    handleCloseReservation: function handleCloseReservation() {
      this.initDialogVisible = false;
      this.handleSearch();
    },
    handleCloseAuthorization: function handleCloseAuthorization() {
      this.authorizationDialogVisible = false;
      this.handleSearch();
    },
    handleDouble: function handleDouble(_ref) {
      var _this5 = this;
      var physicalRow = _ref.physicalRow;
      var select = this.tableData[physicalRow];
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointmentSh.searchFreight)(this.listQuery, select.blNo).then(function (res) {
        if (res.success) {
          _this5.tableCostData = res.data.records;
          _this5.totalCost = res.data.totalRecord;
        }
      }).finally(function () {
        _this5.loading.close();
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    searchFnCost: function searchFnCost(val) {
      this.listQueryTwo.currentPage = val.page;
      this.listQueryTwo.pageSize = val.limit;
      this.handleSearch();
    },
    accreditStatusRenderer: function accreditStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
      var _this6 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value == "1") {
        // link.innerText = '已授权';
        link.innerText = this.$t('blExchangeAppointment.authorized');
      } else {
        link.innerText = this.$t('blExchangeAppointment.unauthorized');
      }
      link.addEventListener('click', function () {
        return _this6.handleAccredit(row);
      });

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleAccredit: function handleAccredit(row) {
      var _this7 = this;
      var rowData = this.$refs.hotTable.getSelected();
      //换单时间未维护不可进行授权操作
      if (!rowData.deliverableDate) {
        this.$message.error(this.$t('blExchangeAppointment.noDeliveryTime'));
        return;
      }
      //未预约不可进行授权操作
      if (!rowData.forespeakStatus) {
        this.$message.error(this.$t('blExchangeAppointment.noReservation'));
        return;
      }
      //查询出授权的数据
      this.accreditBlNo = rowData.blNo;
      this.edoAccreditIds = rowData.edoAccreditId;
      if (!this.edoAccreditIds) {
        this.authorizationDialogVisible = true;
      } else {
        this.loading = (0, _utils.load)();
        (0, _blExchangeAppointmentSh.getForespeak)(rowData.edoAccreditId).then(function (res) {
          if (res.success) {
            _this7.formDialog = res.data;
            _this7.displayType = true;
            _this7.authorizationDialogVisible = true;
          }
        }).finally(function () {
          _this7.loading.close();
        });
      }
    },
    forespeakStatusRenderer: function forespeakStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
      var _this8 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value === 1 || value === 2) {
        link.innerText = this.$t('blExchangeAppointment.reserved');
      }
      // else if (value === 2) {
      //   link.innerText = '预约已保存，在审核附件格式';
      // }
      else if (value === 3) {
        link.innerText = this.$t('blExchangeAppointment.reservationFailed');
      } else {
        link.innerText = this.$t('blExchangeAppointment.notReserved');
      }
      link.addEventListener('click', function () {
        return _this8.handleViewDetail(row);
      });

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleViewDetail: function handleViewDetail(row) {
      var rowDate = this.$refs.hotTable.getSelected();
      if (!rowDate.deliverableDate) {
        this.$message.error(this.$t('blExchangeAppointment.noDeliveryTime1'));
        return;
      }
      this.amount = 0;
      this.vvLBlNo = "VVL:".concat(rowDate.outVesselCode, "/").concat(rowDate.outVoyageNo).concat(rowDate.outVoyageLeg, ",BL:").concat(rowDate.blNo);
      this.edoAccreditId = rowDate.edoAccreditId;
      this.blNos = [rowDate.blNo];
      this.amount = Number(rowDate.amount);
      if (!this.edoAccreditId) {
        this.paymentStatus = rowDate.paymentStatus;
        this.forespeakStatus = rowDate.forespeakStatus;
      }
      this.initDialogVisible = true;
      this.showBtnCancel = false;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      switch (value) {
        case 0:
          td.innerHTML = this.$t('blExchangeAppointment.unSend');
          break;
        case 1:
          td.innerHTML = this.$t('blExchangeAppointment.send');
          break;
        default:
          td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    }
  }
};